var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center",attrs:{"type":"button"},on:{"click":_vm.copy}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),(!_vm.copied)?_c('ClipboardIcon',{staticClass:"w-4 h-4 ml-2"}):_vm._e(),_vm._v(" "),(_vm.copied)?_c('ClipboardCheckIcon',{staticClass:"w-4 h-4 ml-2"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }